var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M407 301c-8.276 0-15 6.724-15 15s6.724 15 15 15 15-6.724 15-15-6.724-15-15-15z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M497 91H151.245v45c0 8.291-6.709 15-15 15s-15-6.709-15-15V91H15c-8.291 0-15 6.709-15 15v90c0 8.291 6.709 15 15 15 24.814 0 45 20.186 45 45s-20.186 45-45 45c-8.291 0-15 6.709-15 15v90c0 8.291 6.709 15 15 15h105v-45c0-8.291 6.709-15 15-15s15 6.709 15 15v45h347c8.291 0 15-6.709 15-15V106c0-8.291-6.709-15-15-15zM150 316c0 8.291-6.709 15-15 15s-15-6.709-15-15v-30c0-8.291 6.709-15 15-15s15 6.709 15 15v30zm0-90c0 8.291-6.709 15-15 15s-15-6.709-15-15v-30c0-8.291 6.709-15 15-15s15 6.709 15 15v30zm92-30c0-24.814 20.186-45 45-45s45 20.186 45 45-20.186 45-45 45-45-20.186-45-45zm36.68 162.48c-6.899-4.6-8.76-13.901-4.16-20.801l120-180c4.585-6.899 13.887-8.745 20.801-4.16 6.899 4.6 8.76 13.901 4.16 20.801l-120 180c-4.525 6.797-13.792 8.806-20.801 4.16zM407 361c-24.814 0-45-20.186-45-45s20.186-45 45-45 45 20.186 45 45-20.186 45-45 45z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M287 181c-8.276 0-15 6.724-15 15s6.724 15 15 15 15-6.724 15-15-6.724-15-15-15z",
    "data-original": "#000000",
    xmlns: "http://www.w3.org/2000/svg"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupon);
export default __webpack_public_path__ + "static/media/cupon.8f99d756232c750ba85345370e20f444.svg";
export { ForwardRef as ReactComponent };